export const SET_API_APPLICATIONS = "SET_API_APPLICATIONS";
export const SET_CREATED_API_APPLICATION = "SET_CREATED_API_APPLICATION";
export const SET_UPDATED_API_APPLICATION = "SET_UPDATED_API_APPLICATION";
export const REMOVE_API_APPLICATION = "REMOVE_DELETED_API_APPLICATION";
export const SET_API_APPLICATION_ERROR = "SET_ROLE_ERROR";
export const SET_API_APPLICATIONS_LOADING = "SET_API_APPLICATIONS_LOADING";
export const SET_API_APPLICATIONS_FETCHING = "SET_API_APPLICATIONS_FETCHING";
